/* eslint-disable prettier/prettier */
import { FaMinus, FaPlus } from 'react-icons/fa6';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import ReactDataTable from '../../../ReactDataTable/ReactDataTable';

const HighlightsBulletpointsForm = ({ remove, add }) => {
    const { values } = useFormikContext();
    const column = [
        // {
        //     name: 'Features Name',
        //     cell: (_, i) => <ReactInput name={`features[${i}].name`} />,
        // },
        {
            name: 'Value',
            cell: (_, i) => <ReactInput name={`highlights_bulletpoints[${i}].value`} />,
        },
        {
            name: <Button onClick={() => add({})}>
                <span style={{
                    fontSize: '14px'
                }}>
                    Action <FaPlus />
                </span>
            </Button>,
            width: '120px',
            cell: (_, i) => (
                <div>
                    {i === 0 ? (
                        <Button onClick={() => add({})}>
                            <FaPlus />
                        </Button>
                    ) : (
                        <Button onClick={() => remove()}>
                            <FaMinus />
                        </Button>
                    )}
                </div>
            ),
        },
    ];
    // Log
    console.log('values highlights_bulletpoints =>', values.highlights_bulletpoints);
    return (
        <div>
            <ReactDataTable
                columns={column}
                data={values.highlights_bulletpoints}
                pagination={false}
            />
            {
                values.length ? (
                    <div
                        style={{
                            width: '100%',
                            position: 'relative',
                            right: '0px',
                        }}
                    >
                        <Button onClick={() => add({})}>
                            <FaPlus />
                        </Button>
                    </div>
                ) : null
            }
        </div>
    );
};
export default HighlightsBulletpointsForm;
